import { SF_COVER_CATEGORIES } from '@om/redux/actions/sizotsaFuneralCover/types';
import {
    getCoverType,
    getMainMemberDetails,
    getEditQuoteDetails,
    getQuoteForm,
    getValueWithThousandSeperator,
    getIncomeStabilizationPremium,
} from '@om/redux/selectors/sizotsaFuneralCover/quote';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    OmButton,
    OmEfpAddCoverDrawer,
    OmFormError,
    OmLoader,
    OmRadioButtonGroup,
    OmSideDrawer,
    OmSlider,
} from '@om/component-library-react';
import {
    addToQuote,
    setBenefitsOnPremimumValue,
    setBenefitsValue,
    setQuoteDetailsStateValue,
    setQuoteDetailsValue,
    setQuoteDrawerValue,
} from '@om/redux/actions/sizotsaFuneralCover/quote';
import { getActivePageIndex } from '@om/redux/selectors/sizotsaFuneralCover/routing';

const FormContent = () => {
    const dispatch = useDispatch();
    const [resetForm,setResetForm]=useState(false)
    const { coverType, formFields, mainMember, editQuoteDetails,activePageIndex,incomeStabilizationPremium } = useSelector(
        createStructuredSelector({
            coverType: getCoverType,
            formFields: getQuoteForm,
            mainMember: getMainMemberDetails,
            editQuoteDetails: getEditQuoteDetails,
            activePageIndex:getActivePageIndex,
            incomeStabilizationPremium:getIncomeStabilizationPremium
        })
    );

    const { benefitsDetails, } = formFields;
  
    const actionHandler = (fieldType, value, displayValue = null) => {
        dispatch(setQuoteDetailsValue({ fieldType, value, displayValue }));
    };
    return (
        <>
            <OmSideDrawer
                open={coverType === SF_COVER_CATEGORIES.BENIFITS}
                onOnSideDrawerClosed={() => {
                    dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: null }));
                    dispatch(
                        setQuoteDetailsStateValue({
                            fieldType: 'editQuoteDetails',
                            value: { id: null, category: null },
                        })
                    );
                    // dispatch(setSideDrawerClosed());
                }}
            >
                <div slot="side-drawer-content">
                    <OmEfpAddCoverDrawer>
                        <div className="progressive-disclosure-form-wrapper">
                            <h5 className="no-top-margin no-bottom-margin medium">Would you like to add benefits?</h5>

                            <span className="mobile-line-break">
                                <br />
                                <br />
                            </span>

                          {/* {mainMemberCover?.value>=20000&& <> <p className="inline-group">
                                <strong>
                                Income Stabilization   <br />
                                </strong>
                                <span className="mobile-line-break no-top-margin small">
                                If you have a cover of E20,000 or more, you can receive E1,000, E1,500, or E2,000 per month for 6 consecutive months after your claim is processed.
                                </span>
                            </p>
                           { incomeStabilization.value &&<OmSlider
                                        key="incomeStabilization"
                                        id="lmskskm"
                                        stepString={JSON.stringify([1000,1500,2000]
                                        )}
                                        minLabel={`E 1000`}
                                        maxLabel={`E 2000`}
                                        value={incomeStabilization?.value ?? 5000}
                                        valuePrefix={'E'}
                                        onSliderChange={(event) => actionHandler('incomeStabilization', event.detail)}
                                    />}
                                     <div className="cover-label-wrapper medium-margin-top" style={{ flexWrap: 'wrap', alignItems: 'center' }}>
                                        <span className="cover-label" style={{width: '50%'}}>
                                            <h5 className="no-bottom-margin no-top-margin medium">
                                               E {getValueWithThousandSeperator(incomeStabilization.value ?? 0)}
                                            </h5>
                                            <h6 className="small medium no-top-margin">COVER AMOUNT</h6>
                                        </span>

                                        <span className="cover-label" style={{width: '50%', textAlign : 'right'}}>
                                            <h5 className="no-bottom-margin no-top-margin medium">
                                                E {monthlyPremium.value??0}
                                            </h5>
                                            <h6 className="small medium no-top-margin base-margin-bottom">MONTHLY PREMIUM</h6>
                                            <h5 className="no-bottom-margin no-top-margin medium">
                                                E {getValueWithThousandSeperator((+monthlyPremium.value * 12).toFixed(2))}
                                            </h5>
                                            <h6 className="small medium no-top-margin">ANNUALLY PREMIUM</h6>
                                        </span>

                                        <span className="no-margin">
                                           
                                        </span>
                                    </div></>} */}
                            <p className="inline-group">
                                <strong>
                                    Cash back* <br />
                                </strong>
                                <span className="mobile-line-break no-top-margin small">
                                    The Cashback benefit pays out 10% of all premiums paid every 5 years, if there was
                                    no claim paid on the policy.
                                </span>
                            </p>
                            <OmRadioButtonGroup
                                vertical="false"
                                groupName="retirement-for"
                                value={benefitsDetails?.value}
                                onOnSelection={(event) => actionHandler('benefitsDetails', event.detail)}
                            >
                                <ul>
                                    <li value={'Yes'}>Yes</li>
                                    <li value={'No'}>No</li>
                                </ul>
                            </OmRadioButtonGroup>
                            <div slot="hint-text">
                                <OmFormError message={benefitsDetails.error} />
                            </div>
                            <span className="mobile-line-break">
                                <br />
                                <br />
                            </span>
                            {/* {age?.value < 50 && ( */}
                                {/* <>
                                    <p className="inline-group">
                                        <strong>
                                            Premium paid up* <br />
                                        </strong>
                                        <p className="mobile-line-break no-top-margin small">
                                            Keeps the policy active when you reach the age of 60, with no additional
                                            premiums required for you and your direct family. This benefit does not
                                            include your parents and extended family members and needs to be active for
                                            at least 10 years.
                                        </p>
                                    </p>
                                    <OmRadioButtonGroup
                                        vertical="false"
                                        groupName="retirement"
                                        value={benefitsDetailsOnPremium?.value}
                                        onOnSelection={(event) =>
                                            actionHandler('benefitsDetailsOnPremium', event.detail)
                                        }
                                    >
                                        <ul>
                                            <li value={'Yes'}>Yes</li>
                                            <li value={'No'}>No</li>
                                        </ul>
                                    </OmRadioButtonGroup>
                                    <div slot="hint-text">
                                        <OmFormError message={benefitsDetailsOnPremium.error} />
                                    </div>
                                </> */}
                            {/* )} */}

                            <div className="action-buttons">
                               {editQuoteDetails.id? <OmButton
                                        type="text"
                                        size="small"
                                        text="CANCEL"
                                        onClick={() => {
                                            dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: null }));
                                            dispatch(
                                                setQuoteDetailsStateValue({
                                                    fieldType: 'editQuoteDetails',
                                                    value: { id: null, category: null },
                                                })
                                            );
                                        }}
                                    />:<OmButton
                                    type="text"
                                    size="small"
                                    text="Clear All"
                                    onClick={() => { 
                                        dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: SF_COVER_CATEGORIES.BENIFITS }))
                                        setResetForm(value=>!value)
                                    }}
                                />}
                                <OmButton
                                    type="primary"
                                    size="small"
                                    text={activePageIndex===2 ? 'SAVE': 'ADD TO QUOTE'}
                                    onClick={() => {
                                        dispatch(
                                            addToQuote({
                                                coverType: SF_COVER_CATEGORIES.BENIFITS,
                                                relation: 'benifit',
                                            })
                                        );
                                    }}
                                />
                            </div>
                        </div>
                    </OmEfpAddCoverDrawer>
                </div>
            </OmSideDrawer>
        </>
    );
};

// const loadingText = (benefitsDrawer) => {
//     return (
//         <>
//             <BenefitsSideDrawerWrapper
//                 drawerIsOpen={benefitsDrawer}
//                 editCategory={EFP_COVER_CATEGORIES.DIRECT_FAMILY}
//             >
//                 <OmLoader loaderText={'Loading...'} isLoading={true} />
//             </BenefitsSideDrawerWrapper>
//         </>
//     );
// };

const BenifitsDrawer = () => {
    // if (applicationReferenceDataValid && quoteReferenceDataValid) {
    return <FormContent />;
    // }

    // return (
    //     <div>
    //         {loadingText(benefitsDrawer)}
    //     </div>
    // );
};

export default BenifitsDrawer;
